import { PPDModal } from '../../../PPDModal';

import "./styles.scss"
import { observer } from 'mobx-react';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export const PPDWidgetLeagueInfoModal = observer(({
    isOpen,
    onClose
}: Props) => {

    return (
        <PPDModal isOpened={isOpen} onClose={onClose} fullHeight={true} className="ppd-widget-league-info-modal">
            <div className="ppd-widget-league-info-modal__content">
                <h2 className="ppd-widget-league-info-modal__title">О рейтинге «Лига первых»</h2>
                <section className="ppd-widget-league-info-modal__section">
                    <h3>Что такое «Лига первых»?</h3>
                    <p>
                        «Лига первых» — это корпоративный рейтинг, в котором показываются сотрудники вашей должности по бутикам
                        одного кластера со всей России. Рейтинг разделяется на два вида:
                        <ol>
                            <li>рейтинг лидеров по выполнению плана;</li>
                            <li>рейтинг лидеров по самым высоким продажам.</li>
                        </ol>
                        <br/>
                        Лидеры, занявшие призовые места согласно турнирной сетке вашего кластера, награждаются медалями как лучшие сотрудники. Медали будут отображаться на
                        странице сотрудника, что будет дополнительно подтверждать лидерский статус.
                    </p>
                </section>

                <section className="ppd-widget-league-info-modal__section">
                    <h3>Как работает рейтинг?</h3>
                    <p>
                        Рейтинг имеет разделение на лиги — группы сотрудников, достигших определенного уровня продаж. Всего
                        в рейтинге четыре лиги:
                        <ol>
                            <li>Железная лига — базовая, не призовая лига</li>
                            <li>Бронзовая лига</li>
                            <li>Серебряная лига</li>
                            <li>Золотая лига</li>
                        </ol>
                        <br/>
                        При этом, внутри призовых лиг, в зависимости от типа распределения призовых мест и количества сотрудников в рейтинге, могут выделяться лидеры лиг,
                        занявшие первые места в своей лиге. Они награждаются особенной медалью, подчеркивающей более высокий статус сотрудника.
                    </p>
                </section>

                <section className="ppd-widget-league-info-modal__section">
                    <h3>Для чего нужен рейтинг и что он дает?</h3>
                    <p>
                        В первую очередь, рейтинг нужен для повышения мотивации сотрудников через внедрение соревновательной
                        практики. Мы собираем всех коллег вашей должности в одном месте и у вас есть прекрасная возможность занять
                        первую строчку среди сотрудников в вашей должности по всей России! Не правда ли, это действительно
                        здорово!
                        <br/>
                        <br/>
                        Во вторую очередь, рейтинг дает понимание о темпах работы коллег в других бутиках, что позволит скорректироваться ваши личные подходы к
                        работе.
                        <br/>
                        <br/>
                        За полученные медали не предусмотрена отдельная финансовая мотивация, но получение медали сопряжено с закрытием определенного количества бонусов, за
                        которые сотрудник получает реальные деньги. Поэтому, чем выше статус медали, тем большее количество бонусов получает сотрудник, а следовательно, больше
                        зарабатывает.
                    </p>
                </section>

                <section className="ppd-widget-league-info-modal__section">
                    <h3>Что в итоге?</h3>
                    <p>
                        Мы искренне верим, что соревновательный принцип и здоровая командная борьба, помогут каждому из нас быть
                        лучше, эффективнее и позволят перешагнуть через планку уже поставленных рекордов! Мы ценим и любим каждого
                        сотрудника нашей большой компании, вне зависимости от полученных медалей, но привнеся дух соперничества
                        в работу команды, каждый сотрудник сможет взглянуть на свою работу под другим углом. Мы искренне надеемся,
                        что это поможет вам в вашей работе и сделает её интереснее и увлекательнее.
                        С уважением, ваш Togas!
                    </p>
                </section>
            </div>
        </PPDModal>
    );
});
